// extracted by mini-css-extract-plugin
module.exports = {"menuheight":"8vh","heroheight":"88vh"};